<script>
/* global L : true*/
import { APIFriendsLocalization } from './../../js/api_friends_localization'
import { bus } from '../../main.js'


export default {
    name: "FriendsLocMixin",

    data() {
        return {
            friends_markers: new Map(),
            generic_icon: null,
        }
    },

    mounted() {
        APIFriendsLocalization.OnStateChanged.push((state) => { this.OnStateChanged(state); });
        APIFriendsLocalization.OnLocationUpdated.push((friends_loc) => { this.onLocationUpdated(friends_loc); });
        APIFriendsLocalization.OnNewFriend.push((name, data) => { this.onNewFriend(name, data); });
        APIFriendsLocalization.OnLostFriend.push((lost_friend) => { this.onLostFriend(lost_friend); });       
        
        bus.$on('zoomFriend', (friend_id) => {
            this.mymap.setView(this.friends_markers.get(friend_id).getLatLng(), 16);
        });
    },

    methods: {
        OnStateChanged(state) {
            if (!state) {
                for (const f_id of this.friends_markers.keys()) {
                    this.friends_markers.get(f_id).remove();
                    this.friends_markers.delete(f_id);
                }
            }
        },

        onNewFriend(f_id, data) {
            const h = ' <p style="margin-bottom: 0px">'+ data.user_name +'</p>\
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill='+data.color+'>\
                            <path d="M0 0h24v24H0z" fill="none"/>\
                            <path d="M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"/>\
                        </svg>';
            const l_icon = L.divIcon({  html: h,
                                        className: 'empty'
                                     });
            const marker = L.marker(data.position, {icon: l_icon});
            marker.addTo(this.mymap);
            this.friends_markers.set(f_id, marker);
        },

        onLostFriend(f_id) {
            this.friends_markers.get(f_id).remove();
            this.friends_markers.delete(f_id);
        },

        onLocationUpdated(friends) {
            for (const f_id of friends.keys()) {
                let marker = this.friends_markers.get(f_id);
                marker.setOpacity(100);
                if (friends.get(f_id).position != undefined)
                    marker.setLatLng(friends.get(f_id).position);
            }
        },

    },
}
</script>